import React from 'react';
import styled from '@emotion/styled';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import P1 from '@base/P1/P1';
import { Fonts, Spacings } from '@styles/index';
import Button from '@base/Button/Button';
import Image from '@base/Image';
import H4 from '@base/H4/H4';
import { useRouter } from 'next/router';
import pushRoute from '@utils/pushRoute';
import { segment } from '@actions/analytics';
import { BANNER_CLICKED } from '@cont/EducatorProfile/constants';
import useGoalEventProps from '@hooks/useGoalEventProps';

interface IMetaProps {
  title: string;
  description: string;
  ctaText: string;
}

interface IMissingChaptersNudgeProps {
  meta?: IMetaProps;
}

const Wrapper = styled.div`
  background-color: var(--color-base-1);
  margin-top: ${Spacings.SPACING_20B};
  padding-top: ${Spacings.SPACING_3B};
  border-radius: ${Spacings.SPACING_2B};
  box-shadow: ${boxShadowGenerator()};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const InfoWrapper = styled.div`
  padding: ${Spacings.SPACING_5B} 0 ${Spacings.SPACING_8B}
    ${Spacings.SPACING_12B};
`;

const StyH4 = styled(H4)`
  font-weight: ${Fonts.SEMIBOLD};
  line-height: ${Spacings.SPACING_6B};
`;

const StyP1 = styled(P1)`
  font-weight: ${Fonts.LIGHT};
  line-height: 18px;
  margin-top: ${Spacings.SPACING_2B};
`;

const StyButton = styled(Button)`
  margin-top: ${Spacings.SPACING_4B};
  font-size: ${Fonts.ULTRA_SMALL};
  line-height: ${Spacings.SPACING_4B};
  font-weight: ${Fonts.HEAVY};
`;

const MissingChaptersNudge: React.FC<IMissingChaptersNudgeProps> = ({
  meta = {}
}) => {
  const { query } = useRouter();
  const { topicUid, conceptUid, goalUID, goalSlug } = query;
  const { ctaText, title, description } = meta;
  // @ts-ignore
  const goalSegmentData = useGoalEventProps({ goalUID });
  const redirectToSyllabusPage = () => {
    segment.track(BANNER_CLICKED, {
      ...goalSegmentData,
      banner_title: 'Educator Library',
      banner_type: 'Introduction'
    });
    pushRoute(
      '/goal/[goalSlug]/[goalUID]/topic/[topicUid]/[conceptUid]',
      `/goal/${goalSlug}/${goalUID}/topic/${topicUid}/${conceptUid}`
    );
  };

  return (
    <Wrapper>
      <InfoWrapper>
        <StyH4 color="var(--color-text-primary)">{title}</StyH4>
        <StyP1 color="var(--color-text-secondary)">{description}</StyP1>
        <StyButton
          // @ts-ignore
          label={ctaText}
          variant="filled"
          color="black"
          maxHeight="xs"
          width="157px"
          onClick={redirectToSyllabusPage}
        />
      </InfoWrapper>
      <Image
        src="syllabus/missing-chapter-image.png"
        alt="syllabus-missing-chapter-image"
        height="150px"
        width="100px"
      />
    </Wrapper>
  );
};

export default MissingChaptersNudge;
